import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';

import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';

interface VideoPlayerProps {
  src: string;
  title?: string;
  onError?: () => void;
  className?: string;
}

export function VideoPlayer({ src, title, onError, className }: VideoPlayerProps) {
  return (
    <div className="flex max-h-full max-w-full items-center justify-center p-6">
      <MediaPlayer
        title={title}
        src={src}
        onError={onError}
        playsInline
        className={`relative max-h-[82vh] max-w-[82vw] overflow-hidden rounded-lg shadow-[0_12px_40px_-8px_rgb(15_23_42/0.35)] ${className ?? ''}`}
      >
        <MediaProvider />
        <DefaultVideoLayout
          icons={defaultLayoutIcons}
          slots={{
            pipButton: null,
            airPlayButton: null,
            googleCastButton: null,
            settingsMenu: null,
            captionButton: null,
            chaptersMenu: null,
          }}
        />
      </MediaPlayer>
    </div>
  );
}
